import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const HeaderContainer = styled(Stack)(() => ({
  background: "#FBFCFE",
  borderBottom: "1px solid #F0F1F5",
  padding: "24px",
  gap: 24,
  "& svg": {
    fontSize: 24,
  },
}));
